/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function certificationRequirements(instance) {
	return {
		/**
		 * @param {number} certificationRequirementId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (certificationRequirementId, config = {}) => {
			return instance.get(
				`retailers/certification_requirements/${certificationRequirementId}`,
				config
			)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(
				`retailers/certification_requirements${params}`,
				config
			)
		},

		/**
		 * @param {number} certificationRequirementId
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (certificationRequirementId, body, config = {}) => {
			return instance.put(
				`retailers/certification_requirements/${certificationRequirementId}`,
				body,
				config
			)
		},

		/**
		 * @param {number} retailerId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (certificationRequirementId, config = {}) => {
			return instance.delete(
				`retailers/certification_requirements/${certificationRequirementId}`,
				config
			)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('retailers/certification_requirements', body, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllByRetailerId: (retailerId, pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(
				`retailers/${retailerId}/certification_requirements${params}`,
				config
			)
		}
	}
}
